import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {Subject} from 'rxjs';
import {startWith, takeUntil} from 'rxjs/operators';
import {MxFormErrorMessageService} from '../../../../services/mx-form-error-message.service';
import {MxField} from '../../services/mxField';
import moment, {Moment} from 'moment-timezone';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {DATE_FORMAT_SECONDS} from '../../../../../../consts/date-time-format-consts';
import {MX_TRANSLATE_SERVICE_TOKEN, MxTranslateService} from "../../../../../../shared/services/mx-translate.service";

@Component({
    selector: 'mx-date-time-field',
    standalone: false,
    templateUrl: './mx-date-time-field.component.html'
})
export class MxDateTimeFieldComponent extends MxField implements OnInit, OnDestroy {

    public dateTimeFormat: string = DATE_FORMAT_SECONDS;

    @Input() maxDate: Moment | null;
    @Input() minDate: Moment | null;

    /**
     * @see this.format
     */
    @Output()
    dateInput: EventEmitter<MatDatepickerInputEvent<Moment>> = new EventEmitter<MatDatepickerInputEvent<Moment>>();

    private _destroy$$: Subject<null> = new Subject<null>();

    constructor(public errorService: MxFormErrorMessageService,
                @Inject(MX_TRANSLATE_SERVICE_TOKEN) protected translateService: MxTranslateService) {
        super(errorService, translateService);
    }

    ngOnInit(): void {
        let componentControl: AbstractControl = this.form.controls[this.name];
        if (componentControl.value) {
            let predefinedValue = this.getPredefinedValue(componentControl.value);
            componentControl.setValue(predefinedValue);
        }

        if (this.fieldConfig && this.fieldConfig.datePickerConfig && this.fieldConfig.datePickerConfig.biggerThan) {
            let dependControl = this.form.controls[this.fieldConfig.datePickerConfig.biggerThan];
            dependControl.valueChanges.pipe(
                startWith(dependControl.value),
                takeUntil(this._destroy$$)
            ).subscribe(value => {
                if (value > componentControl.value) {
                    componentControl.reset();
                    this.minDate = value;
                }
            });
        }
    }

    private getPredefinedValue(value: string): Moment {
        switch (value) {
            case 'NOW':
                return moment();
            default:
                return moment(value);
        }
    }

    onDateChanged($event: MatDatepickerInputEvent<Moment>) {
        this.dateInput.emit($event);
    }

    ngOnDestroy(): void {
        this._destroy$$.next(null);
    }
}
